import React, { useRef } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import s from "./Risk.module.scss";
import { Flex, Progress } from "antd";
import ScrollToTop from "../../Components/ScrollToTop/ScrollToTop";
import useWindowDimensions from "../../Components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../Components/MobileHeader/MobileHeader";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Risk = () => {
  const { width } = useWindowDimensions();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const footerRef = useRef<HTMLDivElement | null>(null);
  const scrollToFooter = () => {
    footerRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <div>
      <div className={s.content}>
        {width > 1100 ? (
          <Header onContactsClick={scrollToFooter} />
        ) : (
          <MobileHeader onContactsClick={scrollToFooter} />
        )}
        <div className={s.title}>{t("Оцените свой риск ВИЧ и туберкулёза")}</div>
        <div className={s.subtitle}>
          <div>{t("С какой ситуацией вы столкнулись?")}</div>
          <div>{t("Выберите ваш маршрут, чтобы получить помощь")}</div>
        </div>
        <div className={s.test}>
          <div className={s.test_title}>
            {t("Мои результаты прохождения теста")}
          </div>

          <div className={s.test_results}>
            <div className={s.item_titles}>
              <div>{t("Блоки")}</div>
              <div>{t("Ответы")}</div>
              <div>{t("Прогресс")}</div>
            </div>
            <div className={s.test_items}>
              <div className={s.test_item}>
                <div className={s.button}>H</div>
              </div>
              <div className={s.test_item}>0/9</div>
              <div className={s.test_item}>0%</div>
              <div className={s.progress_bar}>
                <Flex vertical gap="small" style={{ width: "100%" }}>
                  <Progress
                    percent={30}
                    size="small"
                    showInfo={false}
                    strokeColor="#34c759"
                    strokeWidth={4}
                  />
                </Flex>
              </div>
            </div>
            <div className={s.test_items}>
              <div className={s.test_item}>
                <div className={s.button}>S</div>
              </div>
              <div className={s.test_item}>0/9</div>
              <div className={s.test_item}>0%</div>
              <div className={s.progress_bar}>
                <Flex vertical gap="small" style={{ width: "100%" }}>
                  <Progress
                    percent={1}
                    size="small"
                    showInfo={false}
                    strokeColor="#34c759"
                    strokeWidth={4}
                  />
                </Flex>
              </div>
            </div>
            <div className={s.test_items}>
              <div className={s.test_item}>
                <div className={s.button}>D</div>
              </div>
              <div className={s.test_item}>0/9</div>
              <div className={s.test_item}>0%</div>
              <div className={s.progress_bar}>
                <Flex vertical gap="small" style={{ width: "100%" }}>
                  <Progress
                    percent={15}
                    size="small"
                    showInfo={false}
                    strokeColor="#34c759"
                    strokeWidth={4}
                  />
                </Flex>
              </div>
            </div>
            <div className={s.test_items}>
              <div className={s.test_item}>
                <div className={s.button}>T</div>
              </div>
              <div className={s.test_item}>0/9</div>
              <div className={s.test_item}>0%</div>
              <div className={s.progress_bar}>
                <Flex vertical gap="small" style={{ width: "100%" }}>
                  <Progress
                    percent={0}
                    size="small"
                    showInfo={false}
                    strokeColor="#34c759"
                    strokeWidth={4}
                  />
                </Flex>
              </div>
            </div>
            <div className={s.test_items}>
              <div className={s.test_item}>
                <div className={s.button}>M</div>
              </div>
              <div className={s.test_item}>0/9</div>
              <div className={s.test_item}>0%</div>
              <div className={s.progress_bar}>
                <Flex vertical gap="small" style={{ width: "100%" }}>
                  <Progress
                    percent={80}
                    size="small"
                    showInfo={false}
                    strokeColor="#34c759"
                    strokeWidth={4}
                  />
                </Flex>
              </div>
            </div>
          </div>
        </div>
        <div className={s.buttons}>
          <button className={s.btn} onClick={() => navigate("/test")}>
            <div className={s.img}>
              <img src="/images/play_btn.svg" className={s.btn_icon} />
            </div>

            <div className={s.text}>
              <div className={s.btn_title}>{t("НАЧАТЬ")}</div>
            </div>
          </button>
          <button className={s.btn}>
            <div className={s.img}>
              <img src="/images/Skip.svg" className={s.btn_icon} />
            </div>

            <div className={s.text}>
              <div className={s.btn_title}>{t("ПРОПУСТИТЬ")}</div>
            </div>
          </button>
          <button className={s.btn}>
            <div className={s.img}>
              <img src="/images/Site.svg" className={s.btn_icon} />
            </div>

            <div className={s.text}>
              <div className={s.btn_title}>{t("ПЕРЕЙТИ НА САЙТ")}</div>
            </div>
          </button>
        </div>
      </div>
      <div ref={footerRef}>
        <Footer />
      </div>
      <ScrollToTop />
    </div>
  );
};

export default Risk;
